/** http://www.filamentgroup.com/lab/date_range_picker_using_$_ui_16_and_$_ui_css_framework/ **/
(function ($) {

    $.fn.daterangepicker = function (s) {
        var c = $(this);
        var d = $.extend({
            presetRanges: [{
                text: "Today",
                dateStart: "today",
                dateEnd: "today"
            }, {
                text: "Last 7 days",
                dateStart: "today-7days",
                dateEnd: "today"
            }, {
                text: "Month to date",
                dateStart: function () {
                    return moveToFirstDayOfMonth(today());
                },
                dateEnd: "today"
            }, {
                text: "Year to date",
                dateStart: function () {
                    var w = today();
                    w.setMonth(0);
                    w.setDate(1);
                    return w
                },
                dateEnd: "today"
            }, {
                text: "The previous Month",
                dateStart: function () {
                    return moveToFirstDayOfMonth(parseDateString("1 month ago"))
                },
                dateEnd: function () {
                    return moveToLastDayOfMonth(parseDateString("1 month ago"))
                }
            }],
            presets: {
                specificDate: Alkami.Localization.SiteText["jQuery.DateRangePicker.Options.SpecificDate"],
                allDatesBefore: Alkami.Localization.SiteText["jQuery.DateRangePicker.Options.AllDatesBefore"],
                allDatesAfter: Alkami.Localization.SiteText["jQuery.DateRangePicker.Options.AllDatesAfter"],
                dateRange: Alkami.Localization.SiteText["jQuery.DateRangePicker.Options.DateRange"]
            },
            rangeStartTitle: Alkami.Localization.SiteText["jQuery.DateRangePicker.StartTitle"],
            rangeEndTitle: Alkami.Localization.SiteText["jQuery.DateRangePicker.EndTitle"],
            nextLinkText: Alkami.Localization.SiteText["jQuery.DateRangePicker.NextLink"],
            prevLinkText: Alkami.Localization.SiteText["jQuery.DateRangePicker.PrevLink"],
            doneButtonText: Alkami.Localization.SiteText["jQuery.DateRangePicker.DoneButton"],
            earliestDate: parseDateString("-15years"),
            latestDate: parseDateString("+15years"),
            constrainDates: false,
            rangeSplitter: "-",
            dateFormat: "m/d/yy",
            closeOnSelect: true,
            arrows: false,
            appendTo: "body",
            onClose: function () { },
            onOpen: function () { },
            onChange: function () { },
            datepickerOptions: null
        }, s);
        var f = {
            onSelect: function (z, y) {
                if (i.find(".ui-daterangepicker-specificDate").is(".ui-state-active")) {
                    i.find(".range-end").datepicker("setDate", i.find(".range-start").datepicker("getDate"))
                }
                $(this).trigger("constrainOtherPicker");
                var x = a(i.find(".range-start").datepicker("getDate"));
                var w = a(i.find(".range-end").datepicker("getDate"));
                if (c.length == 2) {
                    c.eq(0).val(x);
                    c.eq(1).val(w)
                } else {
                    c.val((x != w) ? x + " " + d.rangeSplitter + " " + w : x)
                }
                if (d.closeOnSelect) {
                    if (!i.find("li.ui-state-active").is(".ui-daterangepicker-dateRange") && !i.is(":animated")) {
                        j()
                    }
                }
                d.onChange()
            },
            defaultDate: +0
        };
        c.bind("change", d.onChange);
        d.datepickerOptions = (s) ? $.extend(f, s.datepickerOptions) : f;
        var l, k = today();
        var n, h;
        if (c.length == 2) {
            n = parseDateString(c.eq(0).val());
            h = parseDateString(c.eq(1).val());
            if (n == null) {
                n = h
            }
            if (h == null) {
                h = n
            }
        } else {
            n = parseDateString(c.val().split(d.rangeSplitter)[0]);
            h = parseDateString(c.val().split(d.rangeSplitter)[1]);
            if (h == null) {
                h = n
            }
        }
        if (n != null) {
            l = n
        }
        if (h != null) {
            k = h
        }
        var i = $('<div class="ui-daterangepicker ui-widget ui-helper-clearfix ui-widget-content ui-corner-all"></div>');
        var u = (function () {
            var y = $('<ul class="ui-widget-content"></ul>').appendTo(i);
            $.each(d.presetRanges, function () {
                $('<li class="ui-daterangepicker-' + this.text.replace(/ /g, "") + ' ui-corner-all"><a href="#">' + this.text + "</a></li>").data("dateStart", this.dateStart).data("dateEnd", this.dateEnd).appendTo(y)
            });
            var w = 0;
            $.each(d.presets, function (x, z) {
                $('<li class="ui-daterangepicker-' + x + " preset_" + w + ' ui-helper-clearfix ui-corner-all"><span class="ui-icon ui-icon-triangle-1-e"></span><a href="#">' + z + "</a></li>").appendTo(y);
                w++
            });
            y.find("li").on('mouseenter', function () {
                $(this).addClass("ui-state-hover")
            }).on('mouseleave', function () {
                $(this).removeClass("ui-state-hover")
            }).on('click', function () {
                i.find(".ui-state-active").removeClass("ui-state-active");
                $(this).addClass("ui-state-active");
                p($(this), i, m, e);
                return false
            });
            return y
        })();

        function a(y) {
            if (!y.getDate()) {
                return ""
            }
            var x = y.getDate();
            var A = y.getMonth();
            var z = y.getFullYear();
            A++;
            var w = d.dateFormat;
            return $.datepicker.formatDate(w, y)
        }
        $.fn.restoreDateFromData = function () {
            if ($(this).data("saveDate")) {
                $(this).datepicker("setDate", $(this).data("saveDate")).removeData("saveDate")
            }
            return this
        };
        $.fn.saveDateToData = function () {
            if (!$(this).data("saveDate")) {
                $(this).data("saveDate", $(this).datepicker("getDate"))
            }
            return this
        };

        function t() {
            if (i.data("state") == "closed") {
                v();
                i.fadeIn(300).data("state", "open");
                d.onOpen()
            }
        }
        function j() {
            if (i.data("state") == "open") {
                i.fadeOut(300).data("state", "closed");
                d.onClose()
            }
        }
        function b() {
            if (i.data("state") == "open") {
                j()
            } else {
                t()
            }
        }
        function v() {
            var w = o || c;
            var A = w.offset(),
                y = "left",
                z = A.left,
                x = $(window).width() - z - w.outerWidth();
            if (z > x) {
                y = "right", z = x
            }
            i.parent().css(y, z).css("top", A.top + w.outerHeight())
        }
        function p(z, y, A, w) {
            if (z.is(".ui-daterangepicker-specificDate")) {
                $('div.ui-daterangepickercontain').removeClass('larger-container');
                $('div.ui-daterangepickercontain div.ui-daterangepicker ul.ui-widget-content').removeClass('calendar-label-short');
                $('div.ui-daterangepicker').removeClass("larger-modal");
                w.hide();
                A.show();
                y.find(".title-start").text(d.presets.specificDate);
                y.find(".range-end").restoreDateFromData().hide();
                y.find(".range-start").restoreDateFromData().css("opacity", 1).show(400);

                setTimeout(function () {
                    w.fadeIn()
                }, 400)
            } else {
                if (z.is(".ui-daterangepicker-allDatesBefore")) {
                    $('div.ui-daterangepickercontain').removeClass('larger-container');
                    $('div.ui-daterangepickercontain div.ui-daterangepicker ul.ui-widget-content').removeClass('calendar-label-short');
                    $('div.ui-daterangepicker').removeClass("larger-modal");
                    w.hide();
                    A.show();
                    y.find(".title-end").text(d.presets.allDatesBefore);
                    y.find(".range-start").saveDateToData().datepicker("setDate", d.earliestDate).hide();
                    y.find(".range-end").restoreDateFromData().css("opacity", 1).show(400);
                    setTimeout(function () {
                        w.fadeIn()
                    }, 400)
                } else {
                    if (z.is(".ui-daterangepicker-allDatesAfter")) {
                        $('div.ui-daterangepickercontain').removeClass('larger-container');
                        $('div.ui-daterangepickercontain div.ui-daterangepicker ul.ui-widget-content').removeClass('calendar-label-short');
                        $('div.ui-daterangepicker').removeClass("larger-modal");
                        w.hide();
                        A.show();
                        y.find(".title-start").text(d.presets.allDatesAfter);
                        y.find(".range-end").saveDateToData().datepicker("setDate", d.latestDate).hide();
                        y.find(".range-start").restoreDateFromData().css("opacity", 1).show(400);
                        setTimeout(function () {
                            w.fadeIn();
                        }, 400);
                    } else {
                        if (z.is(".ui-daterangepicker-dateRange")) {
                            $('div.ui-daterangepickercontain').addClass('larger-container');
                            $('div.ui-daterangepickercontain div.ui-daterangepicker ul.ui-widget-content').addClass('calendar-label-short');
                            $('div.ui-daterangepicker').addClass("larger-modal");
                            w.hide();
                            A.delay(200).show();
                            y.find(".title-start").text(d.rangeStartTitle);
                            y.find(".title-end").text(d.rangeEndTitle);
                            y.find(".range-start").restoreDateFromData().css("opacity", 1).delay(400).show(400);
                            y.find(".range-end").restoreDateFromData().css("opacity", 1).delay(800).fadeIn(1100);
                            setTimeout(function () {
                                w.fadeIn();
                            }, 400);
                        } else {
                            $('div.ui-daterangepickercontain').removeClass('larger-container');
                            $('div.ui-daterangepickercontain div.ui-daterangepicker ul.ui-widget-content').removeClass('calendar-label-short');
                            $('div.ui-daterangepicker').removeClass("larger-modal");
                            w.hide();
                            y.find(".range-start, .range-end").fadeOut(400, function () {
                                A.hide()
                            });
                            var B = (typeof z.data("dateStart") == "string") ? parseDateString(z.data("dateStart")) : z.data("dateStart")();
                            var x = (typeof z.data("dateEnd") == "string") ? parseDateString(z.data("dateEnd")) : z.data("dateEnd")();
                            y.find(".range-start").datepicker("setDate", B).find(".ui-datepicker-current-day").trigger("click");
                            y.find(".range-end").datepicker("setDate", x).find(".ui-datepicker-current-day").trigger("click")
                        }
                    }
                }
            }
            return false
        }
        var m = $('<div class="ranges ui-widget-header ui-corner-all ui-helper-clearfix"><div class="range-start"><span class="title-start">Start Date</span></div><div class="range-end"><span class="title-end">End Date</span></div></div>').appendTo(i);
        m.find(".range-start, .range-end").datepicker(d.datepickerOptions);
        m.find(".range-start").datepicker("setDate", l);
        m.find(".range-end").datepicker("setDate", k);
        m.find(".range-start, .range-end").bind("constrainOtherPicker", function () {
            if (d.constrainDates) {
                if ($(this).is(".range-start")) {
                    i.find(".range-end").datepicker("option", "minDate", $(this).datepicker("getDate"))
                } else {
                    i.find(".range-start").datepicker("option", "maxDate", $(this).datepicker("getDate"))
                }
            }
        }).trigger("constrainOtherPicker");
        var e = $('<button class="btnDone ui-state-default ui-corner-all">' + d.doneButtonText + "</button>").on('click', function () {
            i.find(".ui-datepicker-current-day").trigger("click");
            j()
        }).on('mouseenter', function () {
            $(this).addClass("ui-state-hover")
        }).on('mouseleave', function () {
            $(this).removeClass("ui-state-hover")
        }).appendTo(m);
        $(this).on('click', function () {
            b();
            return false
        });
        m.hide().find(".range-start, .range-end, .btnDone").hide();
        i.data("state", "closed");
        m.find(".ui-datepicker").css("display", "block");
        $(d.appendTo).append(i);
        i.wrap('<div class="ui-daterangepickercontain"></div>');
        if (d.arrows && c.length == 1) {
            var g = $('<a href="#" class="ui-daterangepicker-prev ui-corner-all" title="' + d.prevLinkText + '"><span class="ui-icon ui-icon-circle-triangle-w">' + d.prevLinkText + "</span></a>");
            var q = $('<a href="#" class="ui-daterangepicker-next ui-corner-all" title="' + d.nextLinkText + '"><span class="ui-icon ui-icon-circle-triangle-e">' + d.nextLinkText + "</span></a>");
            $(this).addClass("ui-rangepicker-input ui-widget-content").wrap('<div class="ui-daterangepicker-arrows ui-widget ui-widget-header ui-helper-clearfix ui-corner-all"></div>').before(g).before(q).parent().find("a").on('click', function () {
                var x = m.find(".range-start").datepicker("getDate");
                var w = m.find(".range-end").datepicker("getDate");
                var y = Math.abs(x.getTime() - w.getTime()) + 86400000;
                if ($(this).is(".ui-daterangepicker-prev")) {
                    y = -y
                }
                m.find(".range-start, .range-end ").each(function () {
                    var z = $(this).datepicker("getDate");
                    if (z == null) {
                        return false
                    }
                    $(this).datepicker("setDate", addMilliseconds(z, y)).find(".ui-datepicker-current-day").trigger("click")
                });
                return false
            }).on('mouseenter', function () {
                $(this).addClass("ui-state-hover")
            }).on('mouseleave', function () {
                $(this).removeClass("ui-state-hover")
            });
            var o = c.parent()
        }
        $(document).on('click', function () {
            if (i.is(":visible")) {
                j()
            }
        });
        i.on('click', function () {
            return false
        }).hide();
        return this
    };

    // Static Date Helpers
    //////////////////////////////////////////////////////////////////////////
    function getMonthNumberFromName(b) {
        var e = CultureInfo.monthNames,
            a = CultureInfo.abbreviatedMonthNames,
            d = b.toLowerCase();
        for (var c = 0; c < e.length; c++) {
            if (e[c].toLowerCase() == d || a[c].toLowerCase() == d) {
                return c
            }
        }
        return -1
    }
    function getDayNumberFromName(b) {
        var f = CultureInfo.dayNames,
            a = CultureInfo.abbreviatedDayNames,
            e = CultureInfo.shortestDayNames,
            d = b.toLowerCase();
        for (var c = 0; c < f.length; c++) {
            if (f[c].toLowerCase() == d || a[c].toLowerCase() == d) {
                return c
            }
        }
        return -1
    }
    function isLeapYear(a) {
        return (((a % 4 === 0) && (a % 100 !== 0)) || (a % 400 === 0))
    }
    function getDaysInMonth(a, b) {
        return [31, (isLeapYear(a) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][b]
    }
    function getTimezoneOffset(a, b) {
        return (b || false) ? CultureInfo.abbreviatedTimeZoneDST[a.toUpperCase()] : CultureInfo.abbreviatedTimeZoneStandard[a.toUpperCase()]
    }
    function validate(d, c, a, b) {
        if (typeof d != "number") {
            throw new TypeError(d + " is not a Number.")
        } else {
            if (d < c || d > a) {
                throw new RangeError(d + " is not a valid value for " + b + ".")
            }
        }
        return true
    }
    function validateMillisecond(a) {
        return validate(a, 0, 999, "milliseconds")
    };
    function validateSecond(a) {
        return validate(a, 0, 59, "seconds")
    };
    function validateMinute(a) {
        return validate(a, 0, 59, "minutes")
    };
    function validateHour(a) {
        return validate(a, 0, 23, "hours")
    };
    function validateDay(c, a, b) {
        return validate(c, 1, getDaysInMonth(a, b), "days")
    };
    function validateMonth(a) {
        return validate(a, 0, 11, "months")
    };
    function validateYear(a) {
        return validate(a, 1, 9999, "seconds")
    };
    function now() {
        return new Date();
    }
    function today() {
        return clearTime(now());
    }


    //Date Prototype Helpers
    //////////////////////////////////////////////////////////////////////////

    function addMilliseconds(d, a) {
        d.setMilliseconds(d.getMilliseconds() + a);
        return d;
    }

    function addSeconds(d, a) {
        return addMilliseconds(d, a * 1000);
    }
    function addMinutes(d, a) {
        return addMilliseconds(d, a * 60000);
    }
    function addHours(d, a) {
        return addMilliseconds(d, a * 3600000);
    }
    function addDays(d, a) {
        return addMilliseconds(d, a * 86400000);
    }
    function addMonths(d, a) {
        var b = d.getDate();
        d.setDate(1);
        d.setMonth(d.getMonth() + a);
        d.setDate(Math.min(b, getDaysInMonth(d.getFullYear(), d.getMonth())));
        return d;
    }
    function addYears(d, a) {
        return addMonths(d, a * 12)
    }
    function addToDate(d, b) {
        if (typeof b == "number") {
            d._orient = b;
            return d
        }
        var a = b;
        if (a.millisecond || a.milliseconds) {
            addMilliseconds(d, a.millisecond || a.milliseconds)
        }
        if (a.second || a.seconds) {
            addSeconds(d, a.second || a.seconds)
        }
        if (a.minute || a.minutes) {
            addMinutes(d, a.minute || a.minutes)
        }
        if (a.hour || a.hours) {
            addHours(d, a.hour || a.hours)
        }
        if (a.month || a.months) {
            addMonths(d, a.month || a.months)
        }
        if (a.year || a.years) {
            addYears(d, a.year || a.years)
        }
        if (a.day || a.days) {
            addDays(d, a.day || a.days)
        }
        return d;
    }
    function setToDate(d, b) {
        var a = b;
        if (!a.millisecond && a.millisecond !== 0) {
            a.millisecond = -1;
        }
        if (!a.second && a.second !== 0) {
            a.second = -1;
        }
        if (!a.minute && a.minute !== 0) {
            a.minute = -1;
        }
        if (!a.hour && a.hour !== 0) {
            a.hour = -1;
        }
        if (!a.day && a.day !== 0) {
            a.day = -1;
        }
        if (!a.month && a.month !== 0) {
            a.month = -1;
        }
        if (!a.year && a.year !== 0) {
            a.year = -1;
        }
        if (a.millisecond != -1 && validateMillisecond(a.millisecond)) {
            addMilliseconds(d, a.millisecond - d.getMilliseconds());
        }
        if (a.second != -1 && validateSecond(a.second)) {
            addSeconds(d, a.second - d.getSeconds());
        }
        if (a.minute != -1 && validateMinute(a.minute)) {
            addMinutes(d, a.minute - d.getMinutes());
        }
        if (a.hour != -1 && validateHour(a.hour)) {
            addHours(d, a.hour - d.getHours());
        }
        if (a.month !== -1 && validateMonth(a.month)) {
            addMonths(d, a.month - d.getMonth());
        }
        if (a.year != -1 && validateYear(a.year)) {
            addYears(d, a.year - d.getFullYear());
        }
        if (a.day != -1 && validateDay(a.day, d.getFullYear(), d.getMonth())) {
            addDays(d, a.day - d.getDate());
        }
        if (a.timezone) {
            setTimezone(d, a.timezone);
        }
        if (a.timezoneOffset) {
            setTimezoneOffset(d, a.timezoneOffset)
        }
        return d;
    }

    function clearTime(d) {
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);
        return d;
    };

    function moveToFirstDayOfMonth(d) {
        d.setDate(1);
        return d;
    }

    function moveToLastDayOfMonth(d) {
        d.setDate(getDaysInMonth(d.getFullYear(), d.getMonth()));

        return d;
    }

    function setTimezoneOffset(d, b) {
        var a = getTimezoneOffset(d),
            c = Number(b) * -6 / 10;
        addMinutes(d, c - a);
        return d;
    }

    function setTimezone(d, a) {
        return setTimezoneOffset(d, getTimezoneOffset(a));
    }


    // Parsing Logic
    //////////////////////////////////////////////////////////////////////////

    var CultureInfo = {
        name: Alkami.Localization.SiteText["jQuery.DateRangePicker.CultureInfo.Name"],
        englishName: Alkami.Localization.SiteText["jQuery.DateRangePicker.CultureInfo.EnglishName"],
        nativeName: Alkami.Localization.SiteText["jQuery.DateRangePicker.CultureInfo.NativeName"],
        dayNames: [
            Alkami.Localization.SiteText["jQuery.Day.Full.Sunday"],
            Alkami.Localization.SiteText["jQuery.Day.Full.Monday"],
            Alkami.Localization.SiteText["jQuery.Day.Full.Tuesday"],
            Alkami.Localization.SiteText["jQuery.Day.Full.Wednesday"],
            Alkami.Localization.SiteText["jQuery.Day.Full.Thursday"],
            Alkami.Localization.SiteText["jQuery.Day.Full.Friday"],
            Alkami.Localization.SiteText["jQuery.Day.Full.Saturday"]
        ],
        abbreviatedDayNames: [
            Alkami.Localization.SiteText["jQuery.Day.Abbr.Sunday"],
            Alkami.Localization.SiteText["jQuery.Day.Abbr.Monday"],
            Alkami.Localization.SiteText["jQuery.Day.Abbr.Tuesday"],
            Alkami.Localization.SiteText["jQuery.Day.Abbr.Wednesday"],
            Alkami.Localization.SiteText["jQuery.Day.Abbr.Thursday"],
            Alkami.Localization.SiteText["jQuery.Day.Abbr.Friday"],
            Alkami.Localization.SiteText["jQuery.Day.Abbr.Saturday"]
        ],
        shortestDayNames: [
            Alkami.Localization.SiteText["jQuery.Day.TwoLetter.Sunday"],
            Alkami.Localization.SiteText["jQuery.Day.TwoLetter.Monday"],
            Alkami.Localization.SiteText["jQuery.Day.TwoLetter.Tuesday"],
            Alkami.Localization.SiteText["jQuery.Day.TwoLetter.Wednesday"],
            Alkami.Localization.SiteText["jQuery.Day.TwoLetter.Thursday"],
            Alkami.Localization.SiteText["jQuery.Day.TwoLetter.Friday"],
            Alkami.Localization.SiteText["jQuery.Day.TwoLetter.Saturday"]
        ],
        firstLetterDayNames: [
            Alkami.Localization.SiteText["jQuery.Day.OneLetter.Sunday"],
            Alkami.Localization.SiteText["jQuery.Day.OneLetter.Monday"],
            Alkami.Localization.SiteText["jQuery.Day.OneLetter.Tuesday"],
            Alkami.Localization.SiteText["jQuery.Day.OneLetter.Wednesday"],
            Alkami.Localization.SiteText["jQuery.Day.OneLetter.Thursday"],
            Alkami.Localization.SiteText["jQuery.Day.OneLetter.Friday"],
            Alkami.Localization.SiteText["jQuery.Day.OneLetter.Saturday"]
        ],
        monthNames: [
            Alkami.Localization.SiteText["jQuery.Month.Full.January"],
            Alkami.Localization.SiteText["jQuery.Month.Full.February"],
            Alkami.Localization.SiteText["jQuery.Month.Full.March"],
            Alkami.Localization.SiteText["jQuery.Month.Full.April"],
            Alkami.Localization.SiteText["jQuery.Month.Full.May"],
            Alkami.Localization.SiteText["jQuery.Month.Full.June"],
            Alkami.Localization.SiteText["jQuery.Month.Full.July"],
            Alkami.Localization.SiteText["jQuery.Month.Full.August"],
            Alkami.Localization.SiteText["jQuery.Month.Full.September"],
            Alkami.Localization.SiteText["jQuery.Month.Full.October"],
            Alkami.Localization.SiteText["jQuery.Month.Full.November"],
            Alkami.Localization.SiteText["jQuery.Month.Full.December"]
        ],
        abbreviatedMonthNames: [
            Alkami.Localization.SiteText["jQuery.Month.Abbr.January"],
            Alkami.Localization.SiteText["jQuery.Month.Abbr.February"],
            Alkami.Localization.SiteText["jQuery.Month.Abbr.March"],
            Alkami.Localization.SiteText["jQuery.Month.Abbr.April"],
            Alkami.Localization.SiteText["jQuery.Month.Abbr.May"],
            Alkami.Localization.SiteText["jQuery.Month.Abbr.June"],
            Alkami.Localization.SiteText["jQuery.Month.Abbr.July"],
            Alkami.Localization.SiteText["jQuery.Month.Abbr.August"],
            Alkami.Localization.SiteText["jQuery.Month.Abbr.September"],
            Alkami.Localization.SiteText["jQuery.Month.Abbr.October"],
            Alkami.Localization.SiteText["jQuery.Month.Abbr.November"],
            Alkami.Localization.SiteText["jQuery.Month.Abbr.December"]
        ],
        amDesignator: "AM",
        pmDesignator: "PM",
        firstDayOfWeek: 0,
        twoDigitYearMax: 2029,
        dateElementOrder: "mdy",
        formatPatterns: {
            shortDate: "M/d/yyyy",
            longDate: "dddd, MMMM dd, yyyy",
            shortTime: "h:mm tt",
            longTime: "h:mm:ss tt",
            fullDateTime: "dddd, MMMM dd, yyyy h:mm:ss tt",
            sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
            universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
            rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT",
            monthDay: "MMMM dd",
            yearMonth: "MMMM, yyyy"
        },
        regexPatterns: {
            jan: /^jan(uary)?/i,
            feb: /^feb(ruary)?/i,
            mar: /^mar(ch)?/i,
            apr: /^apr(il)?/i,
            may: /^may/i,
            jun: /^jun(e)?/i,
            jul: /^jul(y)?/i,
            aug: /^aug(ust)?/i,
            sep: /^sep(t(ember)?)?/i,
            oct: /^oct(ober)?/i,
            nov: /^nov(ember)?/i,
            dec: /^dec(ember)?/i,
            sun: /^su(n(day)?)?/i,
            mon: /^mo(n(day)?)?/i,
            tue: /^tu(e(s(day)?)?)?/i,
            wed: /^we(d(nesday)?)?/i,
            thu: /^th(u(r(s(day)?)?)?)?/i,
            fri: /^fr(i(day)?)?/i,
            sat: /^sa(t(urday)?)?/i,
            future: /^next/i,
            past: /^last|past|prev(ious)?/i,
            add: /^(\+|after|from)/i,
            subtract: /^(\-|before|ago)/i,
            yesterday: /^yesterday/i,
            today: /^t(oday)?/i,
            tomorrow: /^tomorrow/i,
            now: /^n(ow)?/i,
            millisecond: /^ms|milli(second)?s?/i,
            second: /^sec(ond)?s?/i,
            minute: /^min(ute)?s?/i,
            hour: /^h(ou)?rs?/i,
            week: /^w(ee)?k/i,
            month: /^m(o(nth)?s?)?/i,
            day: /^d(ays?)?/i,
            year: /^y((ea)?rs?)?/i,
            shortMeridian: /^(a|p)/i,
            longMeridian: /^(a\.?m?\.?|p\.?m?\.?)/i,
            timezone: /^((e(s|d)t|c(s|d)t|m(s|d)t|p(s|d)t)|((gmt)?\s*(\+|\-)\s*\d\d\d\d?)|gmt)/i,
            ordinalSuffix: /^\s*(st|nd|rd|th)/i,
            timeContext: /^\s*(\:|a|p)/i
        },
        abbreviatedTimeZoneStandard: {
            GMT: "-000",
            EST: "-0400",
            CST: "-0500",
            MST: "-0600",
            PST: "-0700"
        },
        abbreviatedTimeZoneDST: {
            GMT: "-000",
            EDT: "-0500",
            CDT: "-0600",
            MDT: "-0700",
            PDT: "-0800"
        }
    };

    var Parsing = {
        Exception: function (i) {
            this.message = "Parse error at '" + i.substring(0, 10) + " ...'"
        }
    };

    var Grammar = {};
    var Translator = {};


    (function () {
        var a = Parsing;
        var c = a.Operators = {
            rtoken: function (i) {
                return function (j) {
                    var k = j.match(i);
                    if (k) {
                        return ([k[0], j.substring(k[0].length)])
                    } else {
                        throw new a.Exception(j)
                    }
                }
            },
            token: function (i) {
                return function (j) {
                    return c.rtoken(new RegExp("^s*" + j + "s*"))(j)
                }
            },
            stoken: function (i) {
                return c.rtoken(new RegExp("^" + i))
            },
            until: function (i) {
                return function (j) {
                    var k = [],
                        m = null;
                    while (j.length) {
                        try {
                            m = i.call(this, j)
                        } catch (l) {
                            k.push(m[0]);
                            j = m[1];
                            continue
                        }
                        break
                    }
                    return [k, j]
                }
            },
            many: function (i) {
                return function (j) {
                    var m = [],
                        k = null;
                    while (j.length) {
                        try {
                            k = i.call(this, j)
                        } catch (l) {
                            return [m, j]
                        }
                        m.push(k[0]);
                        j = k[1]
                    }
                    return [m, j]
                }
            },
            optional: function (i) {
                return function (j) {
                    var k = null;
                    try {
                        k = i.call(this, j)
                    } catch (l) {
                        return [null, j]
                    }
                    return [k[0], k[1]]
                }
            },
            not: function (i) {
                return function (j) {
                    try {
                        i.call(this, j)
                    } catch (k) {
                        return [null, j]
                    }
                    throw new a.Exception(j)
                }
            },
            ignore: function (i) {
                return i ?
                function (j) {
                    var k = null;
                    k = i.call(this, j);
                    return [null, k[1]]
                } : null
            },
            product: function () {
                var k = arguments[0],
                    l = Array.prototype.slice.call(arguments, 1),
                    m = [];
                for (var j = 0; j < k.length; j++) {
                    m.push(c.each(k[j], l))
                }
                return m
            },
            cache: function (k) {
                var i = {},
                    j = null;
                return function (l) {
                    try {
                        j = i[l] = (i[l] || k.call(this, l))
                    } catch (m) {
                        j = i[l] = m
                    }
                    if (j instanceof a.Exception) {
                        throw j
                    } else {
                        return j
                    }
                }
            },
            any: function () {
                var i = arguments;
                return function (k) {
                    var l = null;
                    for (var j = 0; j < i.length; j++) {
                        if (i[j] == null) {
                            continue
                        }
                        try {
                            l = (i[j].call(this, k))
                        } catch (m) {
                            l = null
                        }
                        if (l) {
                            return l
                        }
                    }
                    throw new a.Exception(k)
                }
            },
            each: function () {
                var i = arguments;
                return function (k) {
                    var n = [],
                        l = null;
                    for (var j = 0; j < i.length; j++) {
                        if (i[j] == null) {
                            continue
                        }
                        try {
                            l = (i[j].call(this, k))
                        } catch (m) {
                            throw new a.Exception(k)
                        }
                        n.push(l[0]);
                        k = l[1]
                    }
                    return [n, k]
                }
            },
            all: function () {
                var j = arguments,
                    i = i;
                return i.each(i.optional(j))
            },
            sequence: function (i, j, k) {
                j = j || c.rtoken(/^\s*/);
                k = k || null;
                if (i.length == 1) {
                    return i[0]
                }
                return function (o) {
                    var p = null,
                        t = null;
                    var v = [];
                    for (var n = 0; n < i.length; n++) {
                        try {
                            p = i[n].call(this, o)
                        } catch (u) {
                            break
                        }
                        v.push(p[0]);
                        try {
                            t = j.call(this, p[1])
                        } catch (m) {
                            t = null;
                            break
                        }
                        o = t[1]
                    }
                    if (!p) {
                        throw new a.Exception(o)
                    }
                    if (t) {
                        throw new a.Exception(t[1])
                    }
                    if (k) {
                        try {
                            p = k.call(this, p[1])
                        } catch (l) {
                            throw new a.Exception(p[1])
                        }
                    }
                    return [v, (p ? p[1] : o)]
                }
            },
            between: function (j, k, i) {
                i = i || j;
                var l = c.each(c.ignore(j), k, c.ignore(i));
                return function (m) {
                    var n = l.call(this, m);
                    return [[n[0][0], r[0][2]], n[1]]
                }
            },
            list: function (i, j, k) {
                j = j || c.rtoken(/^\s*/);
                k = k || null;
                return (i instanceof Array ? c.each(c.product(i.slice(0, -1), c.ignore(j)), i.slice(-1), c.ignore(k)) : c.each(c.many(c.each(i, c.ignore(j))), px, c.ignore(k)))
            },
            set: function (i, j, k) {
                j = j || c.rtoken(/^\s*/);
                k = k || null;
                return function (B) {
                    var l = null,
                        n = null,
                        m = null,
                        o = null,
                        t = [
                            [], B],
                        A = false;
                    for (var v = 0; v < i.length; v++) {
                        m = null;
                        n = null;
                        l = null;
                        A = (i.length == 1);
                        try {
                            l = i[v].call(this, B)
                        } catch (y) {
                            continue
                        }
                        o = [
                            [l[0]], l[1]
                        ];
                        if (l[1].length > 0 && !A) {
                            try {
                                m = j.call(this, l[1])
                            } catch (z) {
                                A = true
                            }
                        } else {
                            A = true
                        }
                        if (!A && m[1].length === 0) {
                            A = true
                        }
                        if (!A) {
                            var w = [];
                            for (var u = 0; u < i.length; u++) {
                                if (v != u) {
                                    w.push(i[u])
                                }
                            }
                            n = c.set(w, j).call(this, m[1]);
                            if (n[0].length > 0) {
                                o[0] = o[0].concat(n[0]);
                                o[1] = n[1]
                            }
                        }
                        if (o[1].length < t[1].length) {
                            t = o
                        }
                        if (t[1].length === 0) {
                            break
                        }
                    }
                    if (t[0].length === 0) {
                        return t
                    }
                    if (k) {
                        try {
                            m = k.call(this, t[1])
                        } catch (x) {
                            throw new a.Exception(t[1])
                        }
                        t[1] = m[1]
                    }
                    return t
                }
            },
            forward: function (i, j) {
                return function (k) {
                    return i[j].call(this, k)
                }
            },
            replace: function (j, i) {
                return function (k) {
                    var l = j.call(this, k);
                    return [i, l[1]]
                }
            },
            process: function (j, i) {
                return function (k) {
                    var l = j.call(this, k);
                    return [i.call(this, l[0]), l[1]]
                }
            },
            min: function (i, j) {
                return function (k) {
                    var l = j.call(this, k);
                    if (l[0].length < i) {
                        throw new a.Exception(k)
                    }
                    return l
                }
            }
        };
        var h = function (i) {
            return function () {
                var j = null,
                        m = [];
                if (arguments.length > 1) {
                    j = Array.prototype.slice.call(arguments)
                } else {
                    if (arguments[0] instanceof Array) {
                        j = arguments[0]
                    }
                }
                if (j) {
                    for (var l = 0, k = j.shift(); l < k.length; l++) {
                        j.unshift(k[l]);
                        m.push(i.apply(null, j));
                        j.shift();
                        return m
                    }
                } else {
                    return i.apply(null, arguments)
                }
            }
        };
        var g = "optional not ignore cache".split(/\s/);
        for (var d = 0; d < g.length; d++) {
            c[g[d]] = h(c[g[d]])
        }
        var f = function (i) {
            return function () {
                if (arguments[0] instanceof Array) {
                    return i.apply(null, arguments[0])
                } else {
                    return i.apply(null, arguments)
                }
            }
        };
        var e = "each any all".split(/\s/);
        for (var b = 0; b < e.length; b++) {
            c[e[b]] = f(c[e[b]])
        }
    } ());
    (function () {
        var f = function (j) {
            var k = [];
            for (var g = 0; g < j.length; g++) {
                if (j[g] instanceof Array) {
                    k = k.concat(f(j[g]))
                } else {
                    if (j[g]) {
                        k.push(j[g])
                    }
                }
            }
            return k
        };
        
        Translator = {
            hour: function (g) {
                return function () {
                    this.hour = Number(g)
                }
            },
            minute: function (g) {
                return function () {
                    this.minute = Number(g)
                }
            },
            second: function (g) {
                return function () {
                    this.second = Number(g)
                }
            },
            meridian: function (g) {
                return function () {
                    this.meridian = g.slice(0, 1).toLowerCase()
                }
            },
            timezone: function (g) {
                return function () {
                    var j = g.replace(/[^\d\+\-]/g, "");
                    if (j.length) {
                        this.timezoneOffset = Number(j)
                    } else {
                        this.timezone = g.toLowerCase()
                    }
                }
            },
            day: function (g) {
                var j = g[0];
                return function () {
                    this.day = Number(j.match(/\d+/)[0])
                }
            },
            month: function (g) {
                return function () {
                    this.month = ((g.length == 3) ? getMonthNumberFromName(g) : (Number(g) - 1))
                }
            },
            year: function (g) {
                return function () {
                    var j = Number(g);
                    this.year = ((g.length > 2) ? j : (j + (((j + 2000) < CultureInfo.twoDigitYearMax) ? 2000 : 1900)))
                }
            },
            rday: function (g) {
                return function () {
                    switch (g) {
                        case "yesterday":
                            this.days = -1;
                            break;
                        case "tomorrow":
                            this.days = 1;
                            break;
                        case "today":
                            this.days = 0;
                            break;
                        case "now":
                            this.days = 0;
                            this.now = true;
                            break
                    }
                }
            },
            finishExact: function (g) {
                g = (g instanceof Array) ? g : [g];
                var j = new Date();
                this.year = j.getFullYear();
                this.month = j.getMonth();
                this.day = 1;
                this.hour = 0;
                this.minute = 0;
                this.second = 0;
                for (var k = 0; k < g.length; k++) {
                    if (g[k]) {
                        g[k].call(this)
                    }
                }
                this.hour = (this.meridian == "p" && this.hour < 13) ? this.hour + 12 : this.hour;
                if (this.day > getDaysInMonth(this.year, this.month)) {
                    throw new RangeError(this.day + " is not a valid value for days.")
                }
                var l = new Date(this.year, this.month, this.day, this.hour, this.minute, this.second);
                if (this.timezone) {
                    setToDate(l, {
                        timezone: this.timezone
                    });
                } else {
                    if (this.timezoneOffset) {
                        setToDate(l, {
                            timezoneOffset: this.timezoneOffset
                        })
                    }
                }
                return l
            },
            finish: function (g) {
                g = (g instanceof Array) ? f(g) : [g];
                if (g.length === 0) {
                    return null
                }
                for (var m = 0; m < g.length; m++) {
                    if (typeof g[m] == "function") {
                        g[m].call(this)
                    }
                }
                if (this.now) {
                    return new Date()
                }
                var j = today();
                var p = null;
                var n = !!(this.days != null || this.orient || this.operator);
                if (n) {
                    var o, l, k;
                    k = ((this.orient == "past" || this.operator == "subtract") ? -1 : 1);
                    if (this.weekday) {
                        this.unit = "day";
                        o = (getDayNumberFromName(this.weekday) - j.getDay());
                        l = 7;
                        this.days = o ? ((o + (k * l)) % l) : (k * l)
                    }
                    if (this.month) {
                        this.unit = "month";
                        o = (this.month - j.getMonth());
                        l = 12;
                        this.months = o ? ((o + (k * l)) % l) : (k * l);
                        this.month = null
                    }
                    if (!this.unit) {
                        this.unit = "day"
                    }
                    if (this[this.unit + "s"] == null || this.operator != null) {
                        if (!this.value) {
                            this.value = 1
                        }
                        if (this.unit == "week") {
                            this.unit = "day";
                            this.value = this.value * 7
                        }
                        this[this.unit + "s"] = this.value * k
                    }
                    return  addToDate(j, this);
                } else {
                    if (this.meridian && this.hour) {
                        this.hour = (this.hour < 13 && this.meridian == "p") ? this.hour + 12 : this.hour
                    }
                    if (this.weekday && !this.day) {
                        this.day = addDays(j, getDayNumberFromName(this.weekday) - j.getDay()).getDate()
                    }
                    if (this.month && !this.day) {
                        this.day = 1
                    }
                    return setToDate(j, this);
                }
            }
        };
        var b = Parsing.Operators,
            e = Grammar,
            d = Translator,
            i;
        e.datePartDelimiter = b.rtoken(/^([\s\-\.\,\/\x27]+)/);
        e.timePartDelimiter = b.stoken(":");
        e.whiteSpace = b.rtoken(/^\s*/);
        e.generalDelimiter = b.rtoken(/^(([\s\,]|at|on)+)/);
        var a = {};
        e.ctoken = function (m) {
            var l = a[m];
            if (!l) {
                var n = CultureInfo.regexPatterns;
                var k = m.split(/\s+/),
                    j = [];
                for (var g = 0; g < k.length; g++) {
                    j.push(b.replace(b.rtoken(n[k[g]]), k[g]))
                }
                l = a[m] = b.any.apply(null, j)
            }
            return l
        };
        e.ctoken2 = function (g) {
            return b.rtoken(CultureInfo.regexPatterns[g])
        };
        e.h = b.cache(b.process(b.rtoken(/^(0[0-9]|1[0-2]|[1-9])/), d.hour));
        e.hh = b.cache(b.process(b.rtoken(/^(0[0-9]|1[0-2])/), d.hour));
        e.H = b.cache(b.process(b.rtoken(/^([0-1][0-9]|2[0-3]|[0-9])/), d.hour));
        e.HH = b.cache(b.process(b.rtoken(/^([0-1][0-9]|2[0-3])/), d.hour));
        e.m = b.cache(b.process(b.rtoken(/^([0-5][0-9]|[0-9])/), d.minute));
        e.mm = b.cache(b.process(b.rtoken(/^[0-5][0-9]/), d.minute));
        e.s = b.cache(b.process(b.rtoken(/^([0-5][0-9]|[0-9])/), d.second));
        e.ss = b.cache(b.process(b.rtoken(/^[0-5][0-9]/), d.second));
        e.hms = b.cache(b.sequence([e.H, e.mm, e.ss], e.timePartDelimiter));
        e.t = b.cache(b.process(e.ctoken2("shortMeridian"), d.meridian));
        e.tt = b.cache(b.process(e.ctoken2("longMeridian"), d.meridian));
        e.z = b.cache(b.process(b.rtoken(/^(\+|\-)?\s*\d\d\d\d?/), d.timezone));
        e.zz = b.cache(b.process(b.rtoken(/^(\+|\-)\s*\d\d\d\d/), d.timezone));
        e.zzz = b.cache(b.process(e.ctoken2("timezone"), d.timezone));
        e.timeSuffix = b.each(b.ignore(e.whiteSpace), b.set([e.tt, e.zzz]));
        e.time = b.each(b.optional(b.ignore(b.stoken("T"))), e.hms, e.timeSuffix);
        e.d = b.cache(b.process(b.each(b.rtoken(/^([0-2]\d|3[0-1]|\d)/), b.optional(e.ctoken2("ordinalSuffix"))), d.day));
        e.dd = b.cache(b.process(b.each(b.rtoken(/^([0-2]\d|3[0-1])/), b.optional(e.ctoken2("ordinalSuffix"))), d.day));
        e.ddd = e.dddd = b.cache(b.process(e.ctoken("sun mon tue wed thu fri sat"), function (g) {
            return function () {
                this.weekday = g
            }
        }));
        e.M = b.cache(b.process(b.rtoken(/^(1[0-2]|0\d|\d)/), d.month));
        e.MM = b.cache(b.process(b.rtoken(/^(1[0-2]|0\d)/), d.month));
        e.MMM = e.MMMM = b.cache(b.process(e.ctoken("jan feb mar apr may jun jul aug sep oct nov dec"), d.month));
        e.y = b.cache(b.process(b.rtoken(/^(\d\d?)/), d.year));
        e.yy = b.cache(b.process(b.rtoken(/^(\d\d)/), d.year));
        e.yyy = b.cache(b.process(b.rtoken(/^(\d\d?\d?\d?)/), d.year));
        e.yyyy = b.cache(b.process(b.rtoken(/^(\d\d\d\d)/), d.year));
        i = function () {
            return b.each(b.any.apply(null, arguments), b.not(e.ctoken2("timeContext")))
        };
        e.day = i(e.d, e.dd);
        e.month = i(e.M, e.MMM);
        e.year = i(e.yyyy, e.yy);
        e.orientation = b.process(e.ctoken("past future"), function (g) {
            return function () {
                this.orient = g
            }
        });
        e.operator = b.process(e.ctoken("add subtract"), function (g) {
            return function () {
                this.operator = g
            }
        });
        e.rday = b.process(e.ctoken("yesterday tomorrow today now"), d.rday);
        e.unit = b.process(e.ctoken("minute hour day week month year"), function (g) {
            return function () {
                this.unit = g
            }
        });
        e.value = b.process(b.rtoken(/^\d\d?(st|nd|rd|th)?/), function (g) {
            return function () {
                this.value = g.replace(/\D/g, "")
            }
        });
        e.expression = b.set([e.rday, e.operator, e.value, e.unit, e.orientation, e.ddd, e.MMM]);
        i = function () {
            return b.set(arguments, e.datePartDelimiter)
        };
        e.mdy = i(e.ddd, e.month, e.day, e.year);
        e.ymd = i(e.ddd, e.year, e.month, e.day);
        e.dmy = i(e.ddd, e.day, e.month, e.year);
        e.date = function (g) {
            return ((e[CultureInfo.dateElementOrder] || e.mdy).call(this, g))
        };
        e.format = b.process(b.many(b.any(b.process(b.rtoken(/^(dd?d?d?|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|tt?|zz?z?)/), function (g) {
            if (e[g]) {
                return e[g]
            } else {
                throw Parsing.Exception(g)
            }
        }), b.process(b.rtoken(/^[^dMyhHmstz]+/), function (g) {
            return b.ignore(b.stoken(g))
        }))), function (g) {
            return b.process(b.each.apply(null, g), d.finishExact)
        });
        var h = {};
        var c = function (g) {
            return h[g] = (h[g] || e.format(g)[0])
        };
        e.formats = function (j) {
            if (j instanceof Array) {
                var k = [];
                for (var g = 0; g < j.length; g++) {
                    k.push(c(j[g]))
                }
                return b.any.apply(null, k)
            } else {
                return c(j)
            }
        };
        e._formats = e.formats(["yyyy-MM-ddTHH:mm:ss", "ddd, MMM dd, yyyy H:mm:ss tt", "ddd MMM d yyyy HH:mm:ss zzz", "d"]);
        e._start = b.process(b.set([e.date, e.time, e.expression], e.generalDelimiter, e.whiteSpace), d.finish);
        e.start = function (g) {
            try {
                var j = e._formats.call({}, g);
                if (j[1].length === 0) {
                    return j
                }
            } catch (k) { }
            return e._start.call({}, g)
        }
    } ());


    function parseDateString(a) {
        var b = null;
        if (!a) {
            return null;
        }
        try {
            b = Grammar.start.call({}, a)
        } catch (c) {
            return null;
        }
        return ((b[1].length === 0) ? b[0] : null);
    }
})(jQuery);